import React, { memo } from 'react';

import { ErrorMessage } from '@/shared/components/ErrorMessage';
import type { TError } from '@/shared/components/ErrorMessage/types';

import { InputComponent, InputLabel, InputWrapper, PartWithOptInfo } from './parts';
import { IPropsBirthdayField } from './types';

const InputForBirthday: React.FC<IPropsBirthdayField> = ({
  label,
  id,
  placeholder = '',
  className = 'InputForBirthday',
  error,
  refInput,
  ...otherProps
}) => {
  const errorId = `${id}-error`;

  return (
    <InputWrapper className={className}>
      <InputLabel
        htmlFor={id}
        className="InputLabel"
        {...(!!error && {
          'aria-describedby': errorId,
        })}
        dangerouslySetInnerHTML={{
          __html: label,
        }}
      />
      <PartWithOptInfo>
        <InputComponent
          {...otherProps}
          className="InputComponent"
          type="text"
          placeholder={placeholder}
          aria-required={false}
          id={id}
          aria-label={label}
          aria-invalid={!!error}
          {...(!!error && {
            'aria-describedby': errorId,
          })}
          autoComplete="off"
          ref={refInput}
        />
        <ErrorMessage error={error as TError} id={errorId} />
      </PartWithOptInfo>
    </InputWrapper>
  );
};

export default memo(InputForBirthday);
